<template>
  <div class="TokenMusicGeneration">
    <div class="page_title">
      <el-divider>
        <div class="page_title_name">音乐生成平台</div>
      </el-divider>
    </div>
    <div class="page_content">
      <p class="page_content_text">AI 音乐与 MV 生成平台是一站式音视频创作工具，依托大模型与扩散算法，支持文生歌、哼唱作曲、歌词生成、分轨导出，可快速产出流行、古风、电子等风格音乐。同步搭载AI MV 智能生成，上传音频即可自动解析节拍、匹配画面与转场，实现音画精准同步，支持角色、场景、风格自定义，一键输出高清成片。零门槛、免专业软件，适配短视频、宣发、自媒体与个人创作，大幅降低制作成本与周期，成为内容创作的高效生产力工具。</p>
      <el-button class="page_content_btn" @click="goToPlatform">进入平台</el-button>
      <img class="page_content_img" src="../../assets/qingye/ai-music-homepage.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  name: "TokenMusicGeneration",
  data() {
    return {
      platformUrl: "https://suno4.cn/#/?i=8NCBS8_WXFF",
    };
  },
  methods: {
    goToPlatform() {
      window.open(this.platformUrl, "_blank");
    },
  },
};
</script>
<style scoped>
.TokenMusicGeneration {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.page_title {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  text-align: center;
  padding-bottom: 20px;
}
.page_title_name {
  font-weight: 600;
  font-size: 26px;
  text-align: center;
}
.page_content {
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}
.page_content_text {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 20px;
  text-indent: 2em;
}
.page_content_btn {
  align-self: center;
  margin-bottom: 20px;
  background-color: #2968BD;
  border-color: #2968BD;
  color: #fff;
  border-radius: 4px;
  padding: 12px 32px;
}
.page_content_btn:hover {
  background-color: #1e4f8f;
  border-color: #1e4f8f;
  color: #fff;
}
.page_content_img {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Token/MusicGeneration.vue